import loadable from '@loadable/component';

const PodcastCard = loadable(() => import('./PodcastCard'));

export default PodcastCard;
